<div class="row ms-0 me-0 mt-1 mb-1">
    <div class="col-12">
        <rb-notification-bar [icon]="'boschicon-bosch-ic-info-i'">
            <div>
                To add your MyGeotab vehicles to the add-in, click <strong>Check new vehicles</strong> in the <strong>Onboard vehicles</strong> tab. If a vehicle doesn't appear, check that it's associated with the <i>"Battery Electric Vehicle"</i> group and has a dongle connected.
                <br />
                To monitor the progress of vehicle onboarding, go to the <strong>Check onboarding status</strong> tab.
            </div>
        </rb-notification-bar>
    </div>
    <rb-tab-panel class="full-width ps-0 pe-0 ms-0 me-0">
        <div *rbTabPanelItem="'Onboard vehicles'" class="content">
            
            <div class="row m-0 p-0 pb-2">
                <div class="col-12 d-flex justify-content-start">
                    <button type="button" class="rb-btn rb-primary" (click)="checkNewVehicles()">
                        <span class="rb-ic rb-ic-car-connected"></span>
                        &nbsp; Check new vehicles
                    </button>
                </div>
            </div>
            <div class="row m-0 p-0">
                <rb-board-item statusIcon="checkmark" class="rb-success">
                    <div *rbBoardItemBody>
                        <h2>Configure your vehicles.</h2>
                        <div class="subline">
                            Select make, model, battery capacity and year for each vehicle below.<br/>
                            If you don't see your vehicle configuration, <a href="mailto:bitcgeotab.support@bosch.com">contact support</a>.
                        </div>
                    </div>
                    <div *rbBoardItemCount>{{supportedVehicles.length}} Supported Vehicles</div>
                </rb-board-item>
            </div>
            <div class="row ms-0 me-0" *ngIf="notSupportedVehicles.length === 0">
                <rb-callout type="warning">
                    No vehicles found!
                </rb-callout>
            </div>
            <div class="row m-0 p-0">
                <div class="col-6 d-flex justify-content-start">
                    <rb-form-input
                    type="text"
                    placeholder="Search..."
                    [(ngModel)]="searchQuery"
                    (ngModelChange)="onSearchChange($event)"
                />
                </div>
            </div>
            <div class="row m-0 p-0" *ngIf="notSupportedVehicles.length > 0">
                <table
                    class="m-table"
                    #repositoryTable
                    rbResizeObserver
                    *rbTable="repositoryLoader; fixedHeaderWidth: true; columns: 7" [rbSort]="{id: '', direction: ''}" (rbSortChange)="onSortChange($event)">
                    <thead>
                        <tr>
                            <th class="col-asset-not-supported-table" rb-sort-header="name" [disableSortClear]="true">Asset</th>
                            <th class="col-make-not-supported-table">Vehicle Make</th>
                            <th class="col-model-not-supported-table">Vehicle Model</th>
                            <th class="col-battery-not-supported-table">Battery Energy (gross / net)</th>
                            <th class="col-year-not-supported-table">Vehicle Year</th>
                            <th class="col-subscribed-not-supported-table" rb-sort-header="enrolled" [disableSortClear]="true">Subscribed (OrderNow)</th>
                            <th class="col-actions-not-supported-table">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let vehicle of notSupportedVehicles; let i = index">
                            <tr
                                class="ic-placeholder"
                                [rbCssTimer]="i"
                                [rbCssTimerEvent]="rowItemChange$"
                                [rbCssTimerSelector]="'td:last-child'"
                                [rbCssTimerSelectorClass]="'table-ic'">
                                <td>
                                    <strong>Name:</strong> {{vehicle.name}} <br/>
                                    <strong>Device:</strong> {{vehicle.batteryIdentifier}} <br/>
                                    <strong>Device Type:</strong> {{vehicle.deviceType === 'CustomVehicleDevice' ? 'OEM' : 'Geotab Dongle'}}
                                </td>
                                <td>
                                    <div class="vin-info-box">
                                        <span class="rb-ic rb-ic-question-frame" rbTooltip="This value is suggested based on VIN data." [noFix]="false"></span>
                                        {{(vehicle?.vinDecoded?.make !== '') ? (vehicle?.vinDecoded?.make + ' (Make from VIN)') : ('N/A (Make from VIN)')}}
                                    </div>
                                    <rb-form-custom-select
                                        name="customBrandSelect"
                                        label="Make*"
                                        [(ngModel)]="vehicle.vehicleBrand"
                                        (ngModelChange)="updateVehicleModelList(i, vehicle._id, vehicle.vehicleBrand, vehicle)"
                                        [selectionTpl]="customBrandSelectMenu">
                                        {{ vehicle.vehicleBrand || '' }}
                                    </rb-form-custom-select>
                                    <ng-template #customBrandSelectMenu let-select="select">
                                        <a
                                            href="javascript:"
                                            class="rb-dropdown-item"
                                            [class.active]="vehicle.vehicleBrand === opt"
                                            (click)="select(opt)"
                                            *ngFor="let opt of getBrandOptionsForVehicle(vehicle)">
                                            {{ opt }}
                                        </a>
                                    </ng-template>
                                </td>
                                <td>
                                    <div class="vin-info-box">
                                        <span class="rb-ic rb-ic-question-frame" rbTooltip="This value is suggested based on VIN data." [noFix]="false"></span>
                                        {{(vehicle?.vinDecoded?.model !== '') ? (vehicle?.vinDecoded?.model + ' (Model from VIN)') : ('N/A (Model from VIN)')}}
                                    </div>
                                    <rb-form-custom-select
                                        name="customModelSelect"
                                        label="Model*"
                                        [(ngModel)]="vehicle.vehicleModel"
                                        (ngModelChange)="updateBatteryEnergyList(i, vehicle.vehicleModel, vehicle)"
                                        [selectionTpl]="customModelSelectMenu"
                                        [disabled]="vehicle.vehicleBrand === ''">
                                        {{ vehicle.vehicleModel || '' }}
                                    </rb-form-custom-select>
                                    <ng-template #customModelSelectMenu let-select="select">
                                        <a
                                            href="javascript:"
                                            class="rb-dropdown-item"
                                            [class.active]="vehicle.vehicleModel === opt"
                                            (click)="select(opt)"
                                            *ngFor="let opt of liveVehicleData[i].vehicleModelList">
                                            {{ opt }}
                                        </a>
                                    </ng-template>
                                </td>
                                <td>
                                    <div class="vin-info-box"></div>
                                    <rb-form-custom-select
                                        name="customBatterySelect"
                                        label="Battery energy - gross / net*"
                                        [(ngModel)]="vehicle.nominalUsableEnergy"
                                        (ngModelChange)="updateModelYearList(i, vehicle.nominalUsableEnergy, vehicle)"
                                        [selectionTpl]="customBatterySelectMenu"
                                        [disabled]="vehicle.vehicleModel === ''">
                                        {{ vehicle.nominalUsableEnergy || '' }}
                                    </rb-form-custom-select>
                                    <ng-template #customBatterySelectMenu let-select="select">
                                        <a
                                            href="javascript:"
                                            class="rb-dropdown-item"
                                            [class.active]="vehicle.nominalUsableEnergy === opt"
                                            (click)="select(opt)"
                                            *ngFor="let opt of liveVehicleData[i].grossEnergyWhList">
                                            {{ opt }}
                                        </a>
                                    </ng-template>
                                </td>
                                <td>
                                    <div class="vin-info-box">
                                        <span class="rb-ic rb-ic-question-frame" rbTooltip="This value is suggested based on VIN data." [noFix]="false"></span>
                                        {{(vehicle?.vinDecoded?.year !== '') ? (vehicle?.vinDecoded?.year + ' (Year from VIN)') : ('N/A (Year from VIN)')}} 
                                    </div>
                                    <rb-form-input
                                        type="number"
                                        name="modelYearInput"
                                        label="Year*"
                                        pattern="^\d+?$"
                                        required
                                        rbNumberConverter
                                        rbMin="2010"
                                        [rbMax]="maxYear"
                                        [(ngModel)]="vehicle.productionYear"
                                        [disabled]="vehicle.nominalUsableEnergy === ''"
                                        (ngModelChange)="updateProductionYear(i, vehicle.productionYear, vehicle)">
                                        <span *rbFormValidationMessage="'required'; onTouched: true">Year is required</span>
                                        <ng-template rbFormValidationMessage="rbMin">Minimum year is 2010</ng-template>
                                        <ng-template rbFormValidationMessage="rbMax">Maximum year is {{maxYear}}</ng-template>
                                    </rb-form-input>
                                </td>
                                <td>
                                    {{ vehicle.enrolled ? 'Yes' : 'No' }}
                                </td>
                                <td>
                                    <div class="vin-info-box"></div>
                                    <button *ngIf="!vehicle.enrolled" type="button" class="rb-btn rb-primary" (click)="updateVehicle(i)" rbTooltip="Please subscribe the vehicle first via OrderNow." [disabled]="vehicle.vehicleBrand === '' || vehicle.vehicleModel === '' || vehicle.nominalUsableEnergy === '' || !vehicle.productionYear || +vehicle.productionYear < 2010 || +vehicle.productionYear > maxYear || vehicle.enrolled === false">
                                        <span class="rb-ic rb-ic-car-cloud-upload"></span>
                                        &nbsp; Add
                                    </button>
                                    <button *ngIf="vehicle.enrolled" type="button" class="rb-btn rb-primary" (click)="updateVehicle(i)" [disabled]="vehicle.vehicleBrand === '' || vehicle.vehicleModel === '' || vehicle.nominalUsableEnergy === '' || !vehicle.productionYear || +vehicle.productionYear < 2010 || +vehicle.productionYear > maxYear">
                                        <span class="rb-ic rb-ic-car-cloud-upload"></span>
                                        &nbsp; Add
                                    </button>
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
            <div class="row d-flex align-items-center justify-content-center m-0 mt-3" *ngIf="notSupportedVehicles.length > 0">
                <rb-pagination [pageData]="pageData" (navigate)="navigateNotSupportedVehicles($event)"></rb-pagination>
            </div>
        </div>
        <div *rbTabPanelItem="'Check onboarding status'" class="content">
            <div class="row m-0 p-0 pb-2">
                <div class="col-12 d-flex justify-content-start">
                    <button type="button" class="rb-btn rb-primary" (click)="checkOrderNow()">
                        <span class="rb-ic rb-ic-car-connected"></span>
                        &nbsp; Check onboarding status
                    </button>
                </div>
            </div>
            <div class="row ms-0 me-0" *ngIf="notIngestedVehicles.length === 0">
                <rb-callout type="warning">
                    No vehicles found!
                </rb-callout>
            </div>
            <div class="row m-0 p-0 pb-2">
                <div class="col-6 d-flex justify-content-start">
                    <rb-form-input
                        type="text"
                        placeholder="Search..."
                        [(ngModel)]="searchQueryIngested"
                        (ngModelChange)="onSearchChangeIngested($event)" />
                </div>
            </div>
            <div class="row m-0 p-0" *ngIf="notIngestedVehicles.length > 0">
                <table
                    class="m-table"
                    #repositoryTable
                    rbResizeObserver
                    *rbTable="repositoryLoader; fixedHeaderWidth: true; columns: 8; enableGhostTable: true; enableScrollButtons: true" [rbSort]="{id: '', direction: ''}" (rbSortChange)="onSortChangeIngested($event)">
                    <thead>
                        <tr>
                            <th class="col-asset-supported-table" rb-sort-header="name" [disableSortClear]="true">Asset</th>
                            <th class="col-configured-supported-table" rb-sort-header="supported" [disableSortClear]="true">Configured</th>
                            <th class="col-subscribed-supported-table" rb-sort-header="enrolled" [disableSortClear]="true">Subscribed (OrderNow)</th>
                            <th class="col-firmware-supported-table" rb-sort-header="firmwareVersion" [disableSortClear]="true">Firmware Version</th>
                            <th class="col-make-supported-table" rb-sort-header="vehicleBrand" [disableSortClear]="true">Vehicle Make</th>
                            <th class="col-model-supported-table" rb-sort-header="vehicleModel" [disableSortClear]="true">Vehicle Model</th>
                            <th class="col-year-supported-table" rb-sort-header="productionYear" [disableSortClear]="true">Vehicle Year</th>
                            <th class="col-actions-supported-table">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let vehicle of notIngestedVehicles; let i = index">
                            <tr
                                class="ic-placeholder"
                                [rbCssTimer]="i"
                                [rbCssTimerEvent]="rowItemChange$"
                                [rbCssTimerSelector]="'td:last-child'"
                                [rbCssTimerSelectorClass]="'table-ic'"
                                [class.table-warning]="vehicle.vinMismatch">
                                <td>
                                    <strong>Name:</strong> {{ vehicle.name }} <span *ngIf="vehicle.vinMismatch" class="rb-ic rb-ic-alert-warning" rbTooltip="Vehicle data doesn't match the VIN information. Click Edit to review and update." position="right" [noFix]="false"></span> <br/>
                                    <strong>Device:</strong> {{vehicle.batteryIdentifier}}
                                </td>
                                <td>
                                    {{ vehicle.supported ? 'Yes' : 'No' }}
                                </td>
                                <td>
                                    {{ vehicle.enrolled ? 'Yes' : 'No' }}
                                </td>
                                <td>
                                    {{ vehicle.firmwareVersion }}
                                </td>
                                <td>
                                    {{ vehicle.vehicleBrand }}
                                </td>
                                <td>
                                    {{ vehicle.vehicleModel }}
                                </td>
                                <td>
                                    {{ (vehicle.productionYear !== '' && vehicle.productionYear !== null) ? vehicle.productionYear : 'N/A' }}
                                </td>
                                <td>
                                    <button *ngIf="isOnboardedToday(vehicle)" type="button" class="rb-btn rb-primary" (click)="openEditVehicleDialog(editVehicle, vehicle)" [disabled]="!vehicle.vinMismatch">
                                        <span class="rb-ic rb-ic-edit"></span>
                                        &nbsp; Edit
                                    </button>
                                    <button *ngIf="!isOnboardedToday(vehicle)" type="button" class="rb-btn rb-primary" (click)="openEditVehicleDialog(editVehicle, vehicle)" [disabled]="isPending(vehicle)">
                                        <span class="rb-ic rb-ic-wrench-change"></span>
                                        &nbsp; {{ isPending(vehicle) ? 'Pending Request' : 'Request Change' }}
                                    </button>
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
            <div class="row d-flex align-items-center justify-content-center m-0 mt-3" *ngIf="notIngestedVehicles.length > 0">
                <rb-pagination [pageData]="pageDataIngested" (navigate)="navigateNotIngestedVehicles($event)"></rb-pagination>
            </div>
        </div>
    </rb-tab-panel>
</div>

<ng-template #editVehicle let-close>
    <rb-dialog dialogTitle="{{isOnboardedToday(oldVehicleData) ? 'Edit Vehicle Configuration' : 'Request Vehicle Configuration Change'}}">
        <div class="row m-0 p-0">
            <div>
                <span><strong>Asset Name:</strong>  {{editableVehicleInfo.name}}</span> <br/>
                <span><strong>Device Serial Number:</strong>  {{editableVehicleInfo.batteryIdentifier}}</span> <br/>
                <span><strong>Device Type:</strong> {{editableVehicleInfo.deviceType === 'CustomVehicleDevice' ? 'OEM' : 'Geotab Dongle'}}</span>
            </div>
        </div>
        <hr>
        <div *ngIf="!isOnboardedToday(oldVehicleData)" class="row m-0 p-0">
            <div>
                <strong>Reason</strong><br/>
                <rb-form-custom-select
                    name="customReasonSelect"
                    label="Please provide the reason*"
                    placeholder="Select reason for change"
                    [(ngModel)]="reason"
                    [selectionTpl]="customReasonSelectMenu">
                    {{ reason || '' }}
                </rb-form-custom-select>
                <ng-template #customReasonSelectMenu let-select="select">
                    <a
                        href="javascript:"
                        class="rb-dropdown-item"
                        [class.active]="reason === opt"
                        (click)="select(opt)"
                        *ngFor="let opt of customReasonSelectOptions">
                        {{ opt }}
                    </a>
                </ng-template>
                <br/>
                <rb-form-textarea *ngIf="reason==='Other reason'"
                    name="changeReason"
                    label="Reason for change*"
                    placeholder="Reason for change"
                    [(ngModel)]="additionalReasonComment"
                    required>
                    <span *rbFormValidationMessage="'required'; onTouched: true">Reason for change is required</span>
                </rb-form-textarea>
            </div>
        </div>
        <hr *ngIf="!isOnboardedToday(oldVehicleData)">
        <div class="row m-0 p-0" *ngIf="reason !== 'Dongle moved to new vehicle'">
            <div class="col-6">
                <strong>Vehicle Make</strong>
                <br/>
                {{'Decoded from VIN: ' + ((editableVehicleInfo?.vinDecoded?.make !== '' && editableVehicleInfo?.vinDecoded?.make !== null) ? (editableVehicleInfo?.vinDecoded?.make) : ('N/A'))}}
                <br/>
                Current value: {{oldVehicleData?.vehicleBrand}}
            </div>
            <div class="col-6 edit-vehicle-callout">
                <rb-callout *ngIf="editableVehicleInfo?.vinDecoded?.make && oldVehicleData?.vehicleBrand"
                    [type]="editableVehicleInfo?.vinDecoded?.make?.toLowerCase() === oldVehicleData?.vehicleBrand?.toLowerCase() ? 'success' : 'warning'">
                    {{
                        editableVehicleInfo?.vinDecoded?.make?.toLowerCase() === oldVehicleData?.vehicleBrand?.toLowerCase()
                        ? 'The make retrieved from the VIN matches the selected value.'
                        : 'Warning: The make retrieved from the VIN does NOT match the selected value.'
                    }}
                </rb-callout>
            </div>
            <rb-form-custom-select
                name="customBrandSelect"
                label="Make*"
                [(ngModel)]="editableVehicleInfo.vehicleBrand"
                (ngModelChange)="updateVehicleModelListEdit(0, editableVehicleInfo._id, editableVehicleInfo.vehicleBrand, editableVehicleInfo)"
                [selectionTpl]="customBrandSelectMenu">
                {{ editableVehicleInfo.vehicleBrand || '' }}
            </rb-form-custom-select>
            <ng-template #customBrandSelectMenu let-select="select">
                <a
                    href="javascript:"
                    class="rb-dropdown-item"
                    [class.active]="editableVehicleInfo.vehicleBrand === opt"
                    (click)="select(opt)"
                    *ngFor="let opt of getBrandOptionsForVehicle(editableVehicleInfo)">
                    {{ opt }}
                </a>
            </ng-template>
        </div>
        <hr *ngIf="reason !== 'Dongle moved to new vehicle'">
        <div class="row m-0 p-0" *ngIf="reason !== 'Dongle moved to new vehicle'">
            <div class="col-6">
                <strong>Vehicle Model</strong>
                <br/>
                {{'Decoded from VIN: ' + ((editableVehicleInfo?.vinDecoded?.model !== '' && editableVehicleInfo?.vinDecoded?.model !== null) ? (editableVehicleInfo?.vinDecoded?.model) : ('N/A'))}}
                <br/>
                Current value: {{oldVehicleData?.vehicleModel}}
            </div>
            <div class="col-6 edit-vehicle-callout">
                <rb-callout *ngIf="editableVehicleInfo?.vinDecoded?.model && oldVehicleData?.vehicleModel"
                    [type]="oldVehicleData?.vehicleModel?.toLowerCase().includes(editableVehicleInfo?.vinDecoded?.model?.toLowerCase()) ? 'success' : 'warning'">
                    {{
                        oldVehicleData?.vehicleModel?.toLowerCase().includes(editableVehicleInfo?.vinDecoded?.model?.toLowerCase())
                        ? 'The model retrieved from the VIN is included in the previously entered value.'
                        : 'Warning: The model retrieved from the VIN is NOT included in the previously entered value.'
                    }}
                </rb-callout>
            </div>
            <rb-form-custom-select
                name="customModelSelect"
                label="Model*"
                [(ngModel)]="editableVehicleInfo.vehicleModel"
                (ngModelChange)="updateBatteryEnergyListEdit(0, editableVehicleInfo.vehicleModel, editableVehicleInfo)"
                [selectionTpl]="customModelSelectMenu"
                [disabled]="editableVehicleInfo.vehicleBrand === ''">
                {{ editableVehicleInfo.vehicleModel || '' }}
            </rb-form-custom-select>
            <ng-template #customModelSelectMenu let-select="select">
                <a
                    href="javascript:"
                    class="rb-dropdown-item"
                    [class.active]="editableVehicleInfo.vehicleModel === opt"
                    (click)="select(opt)"
                    *ngFor="let opt of liveVehicleData[0].vehicleModelList">
                    {{ opt }}
                </a>
            </ng-template>
        </div>
        <hr *ngIf="reason !== 'Dongle moved to new vehicle'">
        <div class="row m-0 p-0" *ngIf="reason !== 'Dongle moved to new vehicle'">
            <div>
                <strong>Battery Energy</strong>
                <br/>
                Current value: {{oldVehicleData?.grossEnergyWh / 1000}} kWh / {{oldVehicleData?.netEnergyWh / 1000}} kWh
            </div>
            <rb-form-custom-select
                name="customBatterySelect"
                label="Battery energy - gross / net*"
                [(ngModel)]="editableVehicleInfo.nominalUsableEnergy"
                (ngModelChange)="updateModelYearListEdit(0, editableVehicleInfo.nominalUsableEnergy, editableVehicleInfo)"
                [selectionTpl]="customBatterySelectMenu"
                [disabled]="editableVehicleInfo.vehicleModel === ''">
                {{ editableVehicleInfo.nominalUsableEnergy || '' }}
            </rb-form-custom-select>
            <ng-template #customBatterySelectMenu let-select="select">
                <a
                    href="javascript:"
                    class="rb-dropdown-item"
                    [class.active]="editableVehicleInfo.nominalUsableEnergy === opt"
                    (click)="select(opt)"
                    *ngFor="let opt of liveVehicleData[0].grossEnergyWhList">
                    {{ opt }}
                </a>
            </ng-template>
        </div>
        <hr *ngIf="reason !== 'Dongle moved to new vehicle'">
        <div class="row m-0 p-0" *ngIf="reason !== 'Dongle moved to new vehicle'">
            <div class="col-6">
                <strong>Vehicle Year</strong>
                <br/>
                {{'Decoded from VIN: ' + ((editableVehicleInfo?.vinDecoded?.year !== '' && editableVehicleInfo?.vinDecoded?.year !== null) ? (editableVehicleInfo?.vinDecoded?.year) : ('N/A'))}}
                <br/>
                Current value: {{oldVehicleData?.modelYear}}
            </div>
            <div class="col-6 edit-vehicle-callout">
                <rb-callout [type]="(+editableVehicleInfo?.vinDecoded?.year === +oldVehicleData?.modelYear) ? 'success' : 'warning'">
                    {{
                        +editableVehicleInfo?.vinDecoded?.year === +oldVehicleData?.modelYear
                        ? 'The model year retrieved from the VIN matches the previously entered value.'
                        : 'Warning: The model year retrieved from the VIN does NOT match the previously entered value.'
                    }}
                </rb-callout>
            </div>
            <rb-form-input
                type="number"
                name="modelYearInput"
                label="Year*"
                pattern="^\d+?$"
                required
                rbNumberConverter
                rbMin="2010"
                [rbMax]="maxYear"
                [(ngModel)]="editableVehicleInfo.productionYear"
                [disabled]="editableVehicleInfo.nominalUsableEnergy === ''"
                (ngModelChange)="updateProductionYearEdit(0, editableVehicleInfo.productionYear, editableVehicleInfo)">
                <span *rbFormValidationMessage="'required'; onTouched: true">Year is required</span>
                <ng-template rbFormValidationMessage="rbMin">Minimum year is 2010</ng-template>
                <ng-template rbFormValidationMessage="rbMax">Maximum year is {{maxYear}}</ng-template>
            </rb-form-input>
        </div>
        <div class="row m-0 p-0" *ngIf="reason === 'Dongle moved to new vehicle'">
            <div class="steps">
                To properly move the device to a new vehicle, please follow these steps:<br/>
                <strong>Step 1: Unplug the device from the old vehicle</strong>
                <ol class="steps-ol">
                    <li class="steps-li">In MyGeotab, navigate to "Vehicles & Assets".</li>
                    <li class="steps-li">Search for and select the <strong>{{editableVehicleInfo.name}}</strong> profile.</li>
                    <li class="steps-li">Click the "Remove" button (in the "Devices & Settings" tab) at the top of the page.</li>
                    <li class="steps-li">Click "Save".</li>
                </ol>
                <strong>Step 2: Add the new vehicle</strong>
                <ol class="steps-ol">
                    <li class="steps-li">Go back to the main "Vehicles & Assets" list.</li>
                    <li class="steps-li">Click "Add a new asset".</li>
                    <li class="steps-li">Enter the details for the new vehicle (Name, VIN, etc.) and type in your existing device serial number.</li>
                    <li class="steps-li">Click "Save".</li>
                </ol>
                <strong>Step 3: Configure the new vehicle</strong>
                <ol class="steps-ol">
                    <li class="steps-li">Go back to the Add-in.</li>
                    <li class="steps-li">Navigate to the "Vehicles" Page.</li>
                    <li class="steps-li">Click the “Add new vehicles” button.</li>
                    <li class="steps-li">Configure the new vehicle in "Configure your vehicle" section.</li>
                    <li class="steps-li">Click "Add".</li>
                </ol>
            </div>
        </div>
        <hr>
        <div class="row m-0 p-0">
            <div class="col-6">
                <button type="button" class="rb-btn rb-secondary edit-vehicle-button" (click)="closeEditVehicle(editVehicle)">
                    <span class="rb-ic rb-ic-close"></span>
                    &nbsp; Cancel
                </button>
            </div>
            <div class="col-6">
                <button *ngIf="isOnboardedToday(oldVehicleData)" type="button" class="rb-btn rb-primary edit-vehicle-button" (click)="editVehicleInfo(editVehicle)" [disabled]="editableVehicleInfo.vehicleBrand === '' || editableVehicleInfo.vehicleModel === '' || editableVehicleInfo.nominalUsableEnergy === '' || !editableVehicleInfo.productionYear || +editableVehicleInfo.productionYear < 2010 || +editableVehicleInfo.productionYear > maxYear">
                    <span class="rb-ic rb-ic-car-cloud-upload"></span>
                    &nbsp; Update
                </button>
                <button *ngIf="!isOnboardedToday(oldVehicleData)" type="button" class="rb-btn rb-primary edit-vehicle-button" (click)="sendEditVehicleInfo(editVehicle)" [disabled]="editableVehicleInfo.vehicleBrand === '' || editableVehicleInfo.vehicleModel === '' || editableVehicleInfo.nominalUsableEnergy === '' || !editableVehicleInfo.productionYear || +editableVehicleInfo.productionYear < 2010 || +editableVehicleInfo.productionYear > maxYear || reason === '' || (reason === 'Other reason' && additionalReasonComment.trim() === '') || reason === 'Dongle moved to new vehicle'">
                    <span class="rb-ic rb-ic-car-cloud-upload"></span>
                    &nbsp; Send Request
                </button>
            </div>
        </div>
    </rb-dialog>
</ng-template>